const CreditReportFactors =[
    {code: "PH", factor: "Payment History", maxValue: 35},
    {code: "CU", factor: "Credit Utilization", maxValue: 30},
    {code: "LC", factor: "Length of Credit History", maxValue: 15},
    {code: "CM", factor: "Credit Mix", maxValue: 10},
    {code: "NC", factor: "New Credit", maxValue: 10}
]
export default CreditReportFactors;